/* eslint-disable */

import {
  AutoComplete,
  Button,
  Checkbox,
  Col,
  ColorPicker,
  Divider,
  Form,
  Image,
  Input,
  Row,
  Select,
  Space,
  Upload,
  message,
} from "antd";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import {
  ImagePreview,
  UploadButton,
  createHandlePreview,
  createHandleUpload,
  getBase64,
} from "../../utils/uploadUtils.jsx";
import React, { useState } from "react";

import permissions from "../../../configs/permission";
import { usePermission } from "../../hooks/usePermission";

const { TextArea } = Input;

export const CreateCompanyDetail = ({
  t,
  formCompany,
  type,
  detailData,
  setColorPrimary,
  setColorSecondary,
  isValidateCreateCompanyAddress,
  isValidateCreateCompanyBillType,
  isValidateCreateCompanyCustomerBillType,
  isValidateCreateCompanyBillPrimaryColor,
  isValidateCreateCompanyBillSecondaryColor,
  fieldBillPrimaryColor,
  fieldBillSecondaryColor,
  setFileListCompanyImage,
  fileListCompanyImage,
  setFileListCustomerImage,
  fileListCustomerImage,
}) => {
  const { hasPermission, isCompanyFullAccess } = usePermission();
  const can = (p) => isCompanyFullAccess || hasPermission(p);

  const [messageApi, contextHolder] = message.useMessage();

  const handleUpload = createHandleUpload(messageApi);

  /* eslint-disable no-template-curly-in-string */
  const validateMessages = {
    required: "${label} is required!",
    types: {
      email: "${label} is not a valid email!",
      number: "${label} is not a valid number!",
    },
    number: {
      range: "${label} must be between ${min} and ${max}",
    },
  };
  /* eslint-enable no-template-curly-in-string */
  const [autoCompleteResult, setAutoCompleteResult] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const onWebsiteChange = (value) => {
    if (!value) {
      setAutoCompleteResult([]);
    } else {
      setAutoCompleteResult([".com", ".org", ".net", ".co.th"].map((domain) => `${value}${domain}`));
    }
  };
  const websiteOptions = autoCompleteResult.map((website) => ({
    label: website,
    value: website,
  }));

  const [colorPrimaryHex, setColorPrimaryHex] = useState(
    type === "EDIT" ? `#${detailData.customer_bill_primary_color}` : "#1677FF"
  );
  const [formatPrimaryHex, setFormatPrimaryHex] = useState("hex");
  const hexPrimaryString = React.useMemo(
    () => (typeof colorPrimaryHex === "string" ? colorPrimaryHex : colorPrimaryHex?.toHexString()),
    [colorPrimaryHex]
  );

  const [colorSecoundaryHex, setColorSecondaryHex] = useState(
    type === "EDIT" ? `#${detailData.customer_bill_secondary_color}` : "#1677FF"
  );
  const [formatSecoundaryHex, setFormatSecoundaryHex] = useState("hex");
  const hexSecoundaryString = React.useMemo(
    () => (typeof colorSecoundaryHex === "string" ? colorSecoundaryHex : colorSecoundaryHex?.toHexString()),
    [colorSecoundaryHex]
  );
  const onSelectColorPrimary = () => {
    isValidateCreateCompanyBillPrimaryColor(hexPrimaryString);
    setColorPrimary(hexPrimaryString);
  };

  const onSelectColorSecoundary = () => {
    isValidateCreateCompanyBillSecondaryColor(hexSecoundaryString);
    setColorSecondary(hexSecoundaryString);
  };

  const companyBillType = [
    {
      value: "BKK",
      label: "BKK",
    },
    {
      value: "ST",
      label: "ST",
    },
  ];

  const customerBillType = [
    {
      value: "BKK",
      label: "BKK",
    },
    {
      value: "ST",
      label: "ST",
    },
  ];

  const handlePreview = createHandlePreview(setPreviewImage, setPreviewOpen);

  const handleChangeCustomerImage = async ({ fileList: newFileList }) => {
    const updatedList = await Promise.all(
      newFileList.map(async (file) => {
        if (file.originFileObj && !file.thumbUrl && !file.url) {
          const base64 = await getBase64(file.originFileObj);
          return { ...file, thumbUrl: base64 };
        }
        return file;
      })
    );
    setFileListCustomerImage(updatedList);
  };

  const handleChangeCompanyImage = async ({ fileList: newFileList }) => {
    const updatedList = await Promise.all(
      newFileList.map(async (file) => {
        if (file.originFileObj && !file.thumbUrl && !file.url) {
          const base64 = await getBase64(file.originFileObj);
          return { ...file, thumbUrl: base64 };
        }
        return file;
      })
    );
    setFileListCompanyImage(updatedList);
  };

  const uploadButton = <UploadButton />;

  return (
    <>
      {contextHolder}
      <Row align="top" justify="center">
        <Col span={12}>
          <Row gutter={10}>
            <Col flex={6}>
              <Form form={formCompany} labelAlign="left" labelCol={{ flex: "180px" }}>
                <Form.Item label={t("Company_Table.Table_Is_Credit") + ":"} name="is_credit" valuePropName="checked">
                  <Checkbox>{t("Company_Create.Create_Detail.Checkbox_Credit")}</Checkbox>
                </Form.Item>
                <Form.Item
                  label={t("Company_Create.Create_Detail.Input_Tax_ID") + ":"}
                  name="tax_id"
                  key="tax_id"
                  style={{ marginBottom: "1rem" }}
                  normalize={(value) => value.trim()}
                  hasFeedback
                >
                  <Input allowClear={true} size="default" placeholder={"tax id"} />
                </Form.Item>
                <Form.Item
                  label={t("Company_Create.Create_Detail.Input_Email") + ":"}
                  name="email"
                  key="email"
                  style={{ marginBottom: "1rem" }}
                  normalize={(value) => value.trim()}
                  rules={[
                    {
                      type: "email",
                    },
                  ]}
                  hasFeedback
                >
                  <Input allowClear={true} size="default" placeholder={"email"} />
                </Form.Item>
                <Form.Item
                  label={t("Company_Create.Create_Detail.Input_Tel") + ":"}
                  name="telephone"
                  key="telephone"
                  style={{ marginBottom: "1rem" }}
                  normalize={(value) => value.trim()}
                  hasFeedback
                >
                  <Input allowClear={true} size="default" maxLength={10} placeholder={"tel"} />
                </Form.Item>
                <Form.Item
                  label={t("Company_Create.Create_Detail.Input_Address") + ":"}
                  name="company_address"
                  key="company_address"
                  style={{ marginBottom: "1rem" }}
                  rules={[{ required: true }, { validator: isValidateCreateCompanyAddress }]}
                  hasFeedback
                >
                  <Input allowClear={true} size="default" placeholder={"address"} />
                </Form.Item>
                <Form.Item
                  label={t("Company_Create.Create_Detail.Input_Note") + ":"}
                  name="note"
                  key="note"
                  style={{ marginBottom: "1rem" }}
                  normalize={(value) => value.trim()}
                >
                  <TextArea allowClear={true} rows={4} />
                </Form.Item>
                <Form.Item
                  label={t("Company_Create.Create_Detail.Input_Website") + ":"}
                  name="website"
                  key="website"
                  style={{ marginBottom: "1rem" }}
                  normalize={(value) => value.trim()}
                  hasFeedback
                >
                  <AutoComplete options={websiteOptions} onChange={onWebsiteChange} placeholder="website">
                    <Input />
                  </AutoComplete>
                </Form.Item>
                <Form.Item
                  label={t("Company_Create.Create_Detail.Input_Bank_Account_Company") + ":"}
                  name="bank_account_company_bill"
                  key="bank_account_company_bill"
                  style={{ marginBottom: "1rem" }}
                  normalize={(value) => value.trim()}
                  hasFeedback
                >
                  <Input allowClear={true} size="default" placeholder={"BANK_NAME/BANK_ACCOUNT_NAME/BANK_ACCOUNT_NO"} />
                </Form.Item>
                <Form.Item
                  label={t("Company_Create.Create_Detail.Input_Company_Bill_Type") + ":"}
                  name="company_bill_type"
                  key="company_bill_type"
                  style={{ marginBottom: "1rem" }}
                  normalize={(value) => value.trim()}
                  rules={[{ required: true }, { validator: isValidateCreateCompanyBillType }]}
                  hasFeedback
                >
                  <Select style={{ width: "100%" }} allowClear options={customerBillType} />
                </Form.Item>
                <Divider />
                <Form.Item
                  label={t("Company_Create.Create_Detail.Input_Bank_Account_Customer") + ":"}
                  name="bank_account_customer_bill"
                  key="bank_account_customer_bill"
                  style={{ marginBottom: "1rem" }}
                  normalize={(value) => value.trim()}
                  hasFeedback
                >
                  <Input allowClear={true} size="default" placeholder={"BANK_NAME/BANK_ACCOUNT_NAME/BANK_ACCOUNT_NO"} />
                </Form.Item>
                <Form.Item
                  label={t("Company_Create.Create_Detail.Input_Customer_Bill_Type") + ":"}
                  name="customer_bill_type"
                  key="customer_bill_type"
                  style={{ marginBottom: "1rem" }}
                  normalize={(value) => value.trim()}
                  rules={[{ required: true }, { validator: isValidateCreateCompanyCustomerBillType }]}
                  hasFeedback
                >
                  <Select style={{ width: "100%" }} allowClear options={companyBillType} />
                </Form.Item>

                <Form.Item
                  label={t("Company_Create.Create_Detail.Input_Bill_Primary_Color") + ":"}
                  key="customer_bill_primary_color"
                  style={{ marginBottom: "1rem" }}
                  rules={[{ required: true }]}
                  hasFeedback
                >
                  <ColorPicker
                    format={formatPrimaryHex}
                    value={colorPrimaryHex}
                    onChange={setColorPrimaryHex}
                    onFormatChange={setFormatPrimaryHex}
                    showText
                  />
                  <Space style={{ margin: "5px" }}>
                    {type === "CREATE" ? (
                      fieldBillPrimaryColor ? (
                        <CheckCircleFilled style={{ color: "#52c41a" }} />
                      ) : (
                        <CloseCircleFilled style={{ color: "#ff4d4f" }} />
                      )
                    ) : (
                      ""
                    )}
                  </Space>
                  <Button type="primary" onClick={onSelectColorPrimary} style={{ top: "-6px", height: "30px" }}>
                    {t("BTN_OK", { ns: "buttons" })}
                  </Button>
                </Form.Item>

                <Form.Item
                  label={t("Company_Create.Create_Detail.Input_Bill_Secondary_Color") + ":"}
                  key="customer_bill_secondary_color"
                  style={{ marginBottom: "1rem" }}
                  rules={[{ required: true }]}
                  hasFeedback
                >
                  <ColorPicker
                    format={formatSecoundaryHex}
                    value={colorSecoundaryHex}
                    onChange={setColorSecondaryHex}
                    onFormatChange={setFormatSecoundaryHex}
                    showText
                  />
                  <Space style={{ margin: "5px" }}>
                    {type === "CREATE" ? (
                      fieldBillSecondaryColor ? (
                        <CheckCircleFilled style={{ color: "#52c41a" }} />
                      ) : (
                        <CloseCircleFilled style={{ color: "#ff4d4f" }} />
                      )
                    ) : (
                      ""
                    )}
                  </Space>
                  <Button type="primary" onClick={onSelectColorSecoundary} style={{ top: "-6px", height: "30px" }}>
                    {t("BTN_OK", { ns: "buttons" })}
                  </Button>
                </Form.Item>
              </Form>
            </Col>
            <Col flex={1}></Col>
          </Row>
        </Col>
        <Col span={12}>
          <Form form={formCompany} labelCol={{ flex: "130px" }}>
            {can(permissions.CompanyBillImage.VIEW) && (
              <Row gutter={10} style={{ justifyContent: "left", alignSelf: "baseline" }}>
                <Col span={24}>
                  <div className="mb-2">{t("Company_Create.Create_Detail.Title_Upload_Company_Bill")}</div>
                  <Upload
                    // beforeUpload={beforeUpload}
                    customRequest={handleUpload}
                    listType="picture-card"
                    fileList={fileListCompanyImage}
                    onPreview={handlePreview}
                    onChange={handleChangeCompanyImage}
                    maxCount={1}
                    disabled={
                      (type === "CREATE" && !can(permissions.CompanyBillImage.ADD)) ||
                      (type === "EDIT" && !can(permissions.CompanyBillImage.CHANGE))
                    }
                    onRemove={() => {
                      const canRemove =
                        hasPermission(permissions.CompanyBillImage.DELETE) ||
                        hasPermission(permissions.CompanyBillImage.ADD) ||
                        hasPermission(permissions.CompanyBillImage.CHANGE);
                      if (!canRemove) {
                        message.warning("You are not allowed to remove this file.");
                        return false;
                      }
                    }}
                  >
                    {fileListCompanyImage.length >= 1 ? null : uploadButton}
                  </Upload>
                  <ImagePreview
                    previewImage={previewImage}
                    previewOpen={previewOpen}
                    setPreviewOpen={setPreviewOpen}
                    setPreviewImage={setPreviewImage}
                    Image={Image}
                  />
                </Col>
              </Row>
            )}
            {can(permissions.CustomerBillImage.VIEW) && (
              <Row gutter={10} style={{ justifyContent: "left", alignSelf: "baseline" }}>
                <Col span={24}>
                  <div className="mt-4 mb-2">{t("Company_Create.Create_Detail.Title_Upload_Customer_Bill")}</div>
                  <Upload
                    customRequest={handleUpload}
                    listType="picture-card"
                    fileList={fileListCustomerImage}
                    onPreview={handlePreview}
                    onChange={handleChangeCustomerImage}
                    maxCount={1}
                    disabled={
                      (type === "CREATE" && !can(permissions.CustomerBillImage.ADD)) ||
                      (type === "EDIT" && !can(permissions.CustomerBillImage.CHANGE))
                    }
                    onRemove={() => {
                      const canRemove =
                        hasPermission(permissions.CustomerBillImage.DELETE) ||
                        hasPermission(permissions.CustomerBillImage.ADD) ||
                        hasPermission(permissions.CustomerBillImage.CHANGE);
                      if (!canRemove) {
                        message.warning("You are not allowed to remove this file.");
                        return false;
                      }
                    }}
                  >
                    {fileListCustomerImage.length >= 1 ? null : uploadButton}
                  </Upload>
                  <ImagePreview
                    previewImage={previewImage}
                    previewOpen={previewOpen}
                    setPreviewOpen={setPreviewOpen}
                    setPreviewImage={setPreviewImage}
                    Image={Image}
                  />
                </Col>
              </Row>
            )}
          </Form>
        </Col>
      </Row>
    </>
  );
};
